import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import UserForm from '../../../components/forms/UserForm';
import { UserClient, UserEditDTO } from '../../../services/apiClient';
import { useNavigate, useParams } from 'react-router-dom';
import { API_BASE_URL } from '../../../config/config';
import Card from '../../../components/common/Card';
import axiosInstance from "../../../services/axiosInstance";

const UserEdit: React.FC = () => {
  const [user, setUser] = useState<UserEditDTO | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [profilePicture, setProfilePicture] = useState<File | null>(null);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const apiClient = new UserClient(API_BASE_URL, axiosInstance);

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Users', href: '/admin/users' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await apiClient.getUserById(id!);
        setUser(response.data as UserEditDTO);
      } catch (error) {
        console.error('Error fetching user:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchUser();
  }, [id]);

  const handleSubmit = async (data: UserEditDTO) => {
    setIsSubmitting(true);
    try {
      if (profilePicture) {
        // Call the method to upload the logo image
        const uploadResponse = await apiClient.uploadProfilePicture(
          profilePicture.name,
          profilePicture,
        );

        if (uploadResponse && uploadResponse.success) {
          data.profilePicture = uploadResponse.data;
        }
      }

      var response = await apiClient.updateUser(id!, data);
      if (response.success && response.data) {
        localStorage.removeItem(`profilePic_${response.data?.id}`)
        navigate('/admin/users');
      }
    } catch (error) {
      console.error('Error updating user:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/users"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Administrator']}
    >
      {isLoading ? (
        <p>Loading...</p>
      ) : (
        <Card title="Edit User">
          <UserForm
            initialValues={user!}
            onSave={handleSubmit}
            setProfilePicture={setProfilePicture}
            onCancel={() => navigate('/admin/users')}
            isCreating={false}
          />
        </Card>
      )}
    </AdminLayout>
  );
};

export default UserEdit;
